export default {
    it: {
        "question": "Note integrative",
        "remaining-characters": "Ti rimangono: ",
        "characters": " caratteri",
    },
    en: {
        "question": "Notes",
        "remaining-characters": "You have ",
        "characters": " characters",
    }
}